// @ts-strict-ignore
/**
 * @owner @Appboy/whats-app
 * @fileoverview GET handler for the "/analytics_dashboard/:app_group_id/kakao_credit_consumption_detail_data" endpoint
 */
import fetch from "@lib/fetch";
import { serializeQueryObjects } from "@lib/serializeQueryObjects";

import { reactQueryTableFetcherAdapter } from "../reactQueryFetcherAdapters";
import { kakaoConsumption } from "./constants";
import type { KakaoConsumptionParams, KakaoConsumptionResult } from "./types";
import { isKakaoConsumptionResult } from "./validators";

export const getDataTableKakaoConsumption = reactQueryTableFetcherAdapter(
  kakaoConsumption,
  (
    signal: AbortSignal,
    { appGroupId, query, groupby, limit = 20, sortby, sortdir, start = 0 }: KakaoConsumptionParams
  ): Promise<KakaoConsumptionResult> => {
    const { start_date, end_date, app_group, month, year, company } = query;

    return fetch(
      `/analytics_dashboard/${appGroupId}/kakao_credit_consumption_detail_data`,
      "GET",
      {
        groupby,
        limit,
        sortby,
        sortdir,
        start,
        app_group_id: appGroupId,
        start_date,
        end_date,
        query: serializeQueryObjects({
          ...(app_group && { app_group }),
          ...(month && { month }),
          ...(year && { year }),
          ...(company && { company }),
        }),
      },
      { signal },
      { propagateFetchRequestError: false }
    );
  },
  isKakaoConsumptionResult
);
